/* eslint no-multi-spaces: ["error", { exceptions: { "ImportDeclaration": true } }] */
import Vue          from 'vue'
import Router       from 'vue-router'

// Pages
import Home         from '../pages/HomePage'

// AUTH Pages
import ChangePass   from '../pages/auth/ChangePassPage'
import Login        from '../pages/auth/LoginPage'
import ResetPass    from '../pages/auth/ResetPassPage'

import { store } from '../store'
import RouterGuard  from '@/router/guard'
const routerGuard = RouterGuard(store)

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: 'Home',
      component: Home,
      beforeEnter: routerGuard.requireUser,
    },
    // AUTH
    {
      path: '/login',
      name: 'Login',
      component: Login,
      beforeEnter: routerGuard.requireGuest,
    },
    {
      path: '/change',
      name: 'Change',
      component: ChangePass,
      beforeEnter: routerGuard.requireUser,
    },
    {
      path: '/reset/:id/:token',
      name: 'Reset',
      component: ResetPass,
      props: true,
      beforeEnter: routerGuard.requireGuest,
    },
    {
      path: '/setup/:id/:token',
      name: 'Setup',
      component: ResetPass,
      props: true,
      beforeEnter: routerGuard.requireGuest,
    },
    {
      path: '*',
      redirect: '/',
    },
  ],
  mode: 'history',
})



// WEBPACK FOOTER //
// ./src/-client-app/router/index.js